module.exports = __webpack_public_path__ + "img/V62.ec232bf1.jpg";